<template>
  <v-container v-if="this.zamawiajacy" class="page">
<table>
  <thead>
  <tr><td>

<div class="cointainer caption" style="margin-top: 0px; margin-bottom: 10px;">
  <div class="left-cointainer">
    <img height="50" class="mt-1" contain src="/static/img/logo-tutore-small.svg">
  </div>
  <div class="right-cointainer">
    Tutore Poland Sp. z o.o.<br>
    ul. Piotrkowska 157A, 90-440 Łódź<br>
    NIP: 7272812193
  </div>
</div>

  </td></tr>
  </thead>
<tbody>
<tr><td>

<p align="center" style="margin-top:20px;">
    <strong>UMOWA ZLECENIE {{ shortNrUmowy() }}</strong>
</p>
<p>
    Zawarta w Łodzi pomiędzy:
</p>
<p><strong>Zleceniodawcą:</strong></p>
<p>
  <strong>Tutore Poland Sp. z o.o.</strong>, z siedzibą w Łodzi przy ul. Piotrkowska 157A, 90-440 Łódź, wpisana do Rejestru
Przedsiębiorców Krajowego Rejestru Sądowego prowadzonego przez Sąd Rejonowy dla Łodzi-Śródmieścia
w Łodzi, XX Wydział Krajowego Rejestru Sądowego pod nr KRS 0000670834, NIP: 727-28-12-193, REGON:
366891567, kapitał zakładowy: 3 500 000 zł, reprezentowaną przez:
<br/>
<br/>
<strong>{{zamawiajacy}}</strong>
</p>

<p>a</p>
</br>
  <strong>Zleceniobiorcą:</strong>
  <br/>
  Imię i nazwisko: {{imieNazwisko}}
  <br/>
  Pesel: {{pesel}}
  <br/>
  Adres: {{zamieszkany}}
  <br/>
  <br/>
  
  <p align="center"><strong>Warunki umowy</strong></p>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 1 Przedmiot umowy</strong>
</p>
<p style="margin-bottom: 0px;">Zleceniodawca zleca, a Zleceniobiorca podejmuje się wykonywania za wynagrodzeniem na rzecz Zleceniodawcy takich czynności jak:
</p>
<ol>
  <li>rzetelne przygotowanie autorskich materiałów edukacyjnych zgodnych z wymaganiami Zleceniodawcy</li>
  <li>rzetelne przygotowanie prezentacji, planów, schematów lekcji, kart pracy i materiałów dla rodzica zgodnych z wymaganiami Zleceniodawcy</li>
  <li>rzetelne przygotowanie ćwiczeń oraz gier onlinowych zgodnych z wymaganiami Zleceniodawcy</li>
  <li>terminowe wykonywanie wszystkich wytycznych organizacyjnych Zleceniodawcy w terminach przez niego określonych</li>
  <li>dbanie o najwyższą jakość wykonywania zlecenia zgodną z wymaganiami Zleceniodawcy</li>
  <li>dbanie o należyty stan mienia Zleceniodawcy oraz o porządek i ład w miejscu wykonywania zlecenia</li>
  <li>współpraca z osobami wyznaczonymi przez Zleceniodawcę</li>
  <li>regularnego i niezwłocznego (najpóźniej na koniec każdego dnia roboczego) odczytywania wiadomości wysyłanych przez osoby wyznaczone przez Zleceniodawcę</li>
  <p>Zleceniobiorcy za pośrednictwem poczty elektronicznej, wiadomości sms lub poprzez komunikatory internetowe i w razie potrzeby jak najszybszego udzielenia odpowiedzi na informacje, w tym szczególnie:</p>
    <ol type="b">
      <li>przekazywanie niezbędnych informacji w zakresie określonym w danej sytuacji</li>
      <li>udział w zebraniach, rozmowach określonych przez Zleceniodawcę terminach</li>
    </ol>
  <li>inne zadania i projekty zlecone przez Zleceniodawcę</li>
</ol>
<p>Celem zapewnienia warunków do wykonania niniejszej Umowy, Zleceniodawca zobowiązuje się do udostępnienia aktualnie posiadanych materiałów dydaktycznych. Powyższe nie obejmuje sprzętu elektronicznego (komputer, sprzęt nagłaśniający, internet itp.), które Zleceniobiorca zobowiązany jest zorganizować na własny koszt.
</p>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 2 Wykonywanie umowy</strong>
</p>
<ol>
  <li>Zleceniobiorca zobowiązuje się wykonywać przedmiot niniejszej umowy z należytą starannością.</li>
  <li>Wykonanie przedmiotu umowy wskazanego w § 1 odbywać się może online za pośrednictwem platform udostępnionych przez Zleceniodawcę, w formule stacjonarnej w wybranej placówce Zleceniodawcy, u Klienta lub w placówce wskazanej przez Zleceniodawcę.</li>
  <li>Zleceniobiorca będzie wykonywać usługi objęte niniejszą umową w warunkach całkowitej niezależności od Zleceniodawcy. W szczególności Zleceniodawca nie będzie uprawniony do wykonywania wobec Zleceniobiorcy jakichkolwiek praw kierowniczych, nie ingerując w organizację i/lub dyscyplinę pracy Zleceniobiorcy. Wszelkie problemy techniczne lub metodologiczne dotyczące całości powierzonych Zleceniobiorcy czynności będą rozwiązywane przez wspólne porozumienie Stron, z poszanowaniem niezależności działalności zawodowej prowadzonej przez Zleceniobiorcę.</li>
  <li>Zleceniobiorca nie może powierzyć wykonania przedmiotu niniejszej umowy osobie trzeciej.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 3 Obowiązek informacyjny</strong>
</p>
  <ol>
    <li>Zleceniodawca zobowiązany jest dostarczać Zleceniobiorcy wszelkich informacji niezbędnych do realizacji przez niego przedmiotu umowy oraz poszczególnych Zleceń.</li>
    <li>Zleceniobiorca zobowiązany jest udzielać Zleceniodawcy potrzebnych informacji o przebiegu realizacji przez niego przedmiotu umowy oraz poszczególnych Zleceń.</li>
  </ol>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 4 Absencje i powiadamianie o nich</strong>
</p>
  <ol>
    <li>W przypadku nagłej niedyspozycji wynikającej z choroby lub złego stanu zdrowia, które wystąpiło nagle, Zleceniobiorca może nie zachować 7-dniowego okresu powiadomienia o niemożności wykonywania zlecenia. Zleceniobiorca zobowiązuje się niezwłocznie, nie później niż 4 godziny po wystąpieniu zdarzenia powiadomić o takiej sytuacji Zleceniodawcę.</li>
    <li>W przypadku nagłej niedyspozycji wynikającej z choroby lub złego stanu zdrowia, które wystąpiło nagle, Zleceniobiorca może nie zachować 7-dniowego okresu powiadomienia o niemożności wykonywania zlecenia, jednak zobowiązany jest do poinformowania Zleceniodawcy niezwłocznie po zaistnieniu takiego zdarzenia. Zleceniobiorca potwierdza to, na podstawie e-zwolnienia lekarskiego, które wpłynie na profil Zleceniodawcy w portalu PUE ZUS.</li>
  </ol>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 5 Czas trwania umowy i okres wypowiedzenia</strong>
</p>
<ol>
  <li>Strony zawierają umowę od dnia {{ dataObowiazywaniaUmowy() }} do dnia {{ umowaDo !== '30-12-1899' ? umowaDo : '31-08-2024' }} r.</li>
  <li>Strony mogą rozwiązać umowę z zachowaniem miesięcznego okresu wypowiedzenia, ze skutkiem prawnym na koniec następnego miesiąca kalendarzowego, po pisemnym przesłaniu informacji o wypowiedzeniu umowy (z zastrzeżeniem ust. 3 niniejszego paragrafu).</li>
  <li>Zleceniodawca ma prawo rozwiązać niniejszą umowę bez zachowania okresu wypowiedzenia w przypadkach wskazanych w Umowie, a także w sytuacji braku możliwości powierzenia przedmiotu niniejszej umowy lub jeżeli Zleceniobiorca narusza postanowienia niniejszej Umowy, przez co strony rozumieją w szczególności:
    <ol type="a">
      <li>zachowanie Zleceniobiorcy polegające na niewykonywaniu obowiązków określonych w § 1 pomimo uprzedniego wezwania ze strony Zleceniodawcy do zaniechania naruszeń,</li>
      <li>złamanie przez Zleceniobiorcę zakazu konkurencji,</li>
      <li>ujawnienie przez Zleceniobiorcę Informacji Poufnych,</li>
      <li>wszelkie inne naruszenia niniejszej umowy.</li>
    </ol>
  </li>
  <li>W przypadku rozwiązania umowy Zleceniobiorca zobowiązuje się do zwrotu materiałów udostępnionych na czas trwania umowy przez Zleceniodawcę w terminie do 14 dni od dnia rozwiązania lub wygaśnięcia umowy. W przypadku braku zwrotu materiałów w wyznaczonym terminie Zleceniodawca może nałożyć na Zleceniobiorcę karę finansową o wartości otrzymanych materiałów. Dodatkowo Zleceniobiorca może zostać obciążony kosztami przesyłki.
</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 6 Wynagrodzenie</strong>
  </p>
<ol>
  <li>Z tytułu prawidłowego wykonania czynności wymienionych w § 1 Umowy oraz powierzonych Zleceniobiorcy Zleceń, Zleceniobiorca otrzyma wynagrodzenie  w wysokości:</li>
  <div v-html="usluga"></div>
  <br/>
  <li>Wypłata wynagrodzenia za każdy miesiąc wykonywania zlecenia następuje z dołu, 15-tego dnia następnego miesiąca kalendarzowego następującego po miesiącu rozliczenia, w wysokości określonej powyżej, w oparciu o zestawienie, o którym mowa w ust. 8 poniżej, na numer konta bankowego wskazanego przez Zleceniobiorcę.</li>
  <li>Całkowite miesięczne wynagrodzenie będzie wynikać ze stawki godzinowej wynikającej z ust. 1 niniejszego paragrafu.</li>
</ol>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 7 Premia</strong>
  </p>
<ol>
  <li>Zleceniodawca może przyznać Zleceniobiorcy premię uznaniową w wysokości do 15% wynagrodzenia brutto, której przyznanie jest uzależnione od stopnia realizacji przydzielonych zadań indywidualnych. Zadania indywidualne na kolejny miesiąc będą przedstawiane z odpowiednim wyprzedzeniem.</li>
  <li>Dodatkowo Zleceniodawca może przyznać dodatkową premię uznaniową za inne cele niezwiązane z ust. 1 niniejszego paragrafu.</li>
  <li>Premia nie ma charakteru roszczeniowego, zaś jej przyznanie, jak i określenie jej wysokości należy do swobodnego uznania Zleceniodawcy.</li>
  <li>Wyliczenie i wypłata premii następuje w ciągu 15 dni od zakończenia miesięcznego okresu rozliczeniowego.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 8 Prawa autorskie</strong>
  </p>
<ol>
  <li>Zleceniobiorca zobowiązuje się do przeniesienia na Zleceniodawcę autorskich praw majątkowych do utworów powstałych w wyniku wykonywania niniejszej umowy (dalej: Utwór). Zleceniobiorca oświadcza, że przysługują mu zarówno autorskie prawa majątkowe, jak i autorskie prawa osobiste do Utworu. Prawa te nie są ograniczone ani obciążone na rzecz osób trzecich. Przeniesienie przez Zleceniobiorcę na Zleceniodawcę autorskich praw majątkowych do Utworu nastąpi z chwilą przyjęcia Utworu. Poprzez przyjęcie Utworu rozumie się jego zaakceptowanie i uznanie przez Zleceniodawcę, że nie posiada on wad, co potwierdzane jest podpisem Zleceniodawcy na elektronicznym Arkuszu Stworzonych Materiałów oraz poprzez e-mailowy protokół zdawczo odbiorczy. Razem z przejściem autorskich praw majątkowych, na Zleceniodawcę przechodzi wyłączne prawo do wykonywanie autorskiego prawa zależnego do Utworu.</li>
  <li>W przypadku wystąpienia przez jakąkolwiek osobę wobec Zleceniodawcy z roszczeniem opartym na twierdzeniu, że dostarczony przez Zleceniobiorcę Utwór narusza jej jakiekolwiek prawa, Zleceniobiorca ma obowiązek niezwłocznie, nie później niż w terminie 7 dni od dnia poinformowania Zleceniobiorcy o roszczeniu, dostarczyć nowy przedmiot zlecenia Zleceniodawcy, który nie narusza praw osób trzecich (wolne od wad prawnych) oraz ponosi odpowiedzialność za naprawienie szkody wyrządzonej tym osobom, zwalniając z odpowiedzialności Zleceniodawcę, poprzez przejęcie na siebie zaspokojenia słusznych roszczeń osób lub podmiotów trzecich.</li>
  <li>W przypadku niewykonania przez Zleceniobiorcę zobowiązania określonego w ust. 2 niniejszego paragrafu we wskazanym w tym ustępie terminie, Zleceniodawcy przysługują wszystkie niżej wymienione uprawnienia, które ma prawo zrealizować według własnego wyboru (łącznie lub osobno):
    <ol type="a">
      <li>prawo odstąpienia od umowy z wyłączeniem możliwości dochodzenia poniesionych przez Zleceniobiorcę kosztów, wynagrodzeń, odszkodowań itp.,</li>
      <li>prawo żądania od Zleceniobiorcy zapłaty kary umownej w wysokości 20 000,00 zł (słownie: dwudziestu tysięcy złotych) oraz prawo żądania odszkodowania uzupełniającego na zasadach ogólnych Kodeksu cywilnego,</li>
      <li>w przypadku wytoczenia przeciwko Zleceniodawcy powództwa opartego na twierdzeniu opisanym w ust. 2 niniejszego paragrafu, Zleceniobiorca zobowiązuje się ponieść wszelkie inne koszty postępowania sądowego, a także prawne skutki zapadłego orzeczenia. Zleceniodawca zobowiązany jest niezwłocznie zawiadomić Zleceniobiorcę o toczącym się postępowaniu.</li>
    </ol>
  </li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 9 Pola eksploatacyjne</strong>
  </p>
<ol>
  <li>Z chwilą przyjęcia przedmiotu zlecenia zgodnie z § 1 ust. 1 Zleceniobiorca przenosi na Zleceniodawcę autorskie prawa majątkowe do przedmiotu zlecenia bez ograniczeń terytorialnych na następujących polach eksploatacji:
   <ol type="a">
    <li>w zakresie utrwalania i zwielokrotniania przedmiotu zlecenia określoną techniką, w tym techniką drukarską, reprograficzną, zapisu magnetycznego oraz techniką cyfrową,</li>
    <li>w zakresie wprowadzania przedmiotu zlecenia do obrotu, użyczania lub najmu jego egzemplarzy,</li>
    <li>w zakresie wykonania, nadawania, reemitowania oraz odtwarzania przedmiotu zlecenia, a także umieszczenia jego utrwalenia na stronie internetowej Zleceniodawcy, na koncie Zleceniodawcy na Facebooku oraz w serwisie YouTube,</li>
    <li>rozpowszechnianie we wszelkich formach, co obejmuje w szczególności wystawianie, wyświetlanie, odtwarzanie, nadawanie, reemitowanie, a także publiczne udostępnianie w taki sposób, aby każdy mógł mieć do nich dostęp w miejscu i w czasie przez siebie wybranym,</li>
    <li>modyfikowanie, co obejmuje w szczególności prawo do korekty, dokonywania przeróbek i zmian całości lub poszczególnych elementów,</li>
    <li>tworzenie i rozpowszechnianie utworów zależnych, w tym dalszych utworów opartych na utworach lub ich poszczególnych elementach, co obejmuje w szczególności tłumaczenie, zmiany elementów graficznych, kolorystycznych, formatów wizualnych i przestrzennych, a także korzystanie z tak powstałych utworów zależnych w zakresie i na wszystkich polach eksploatacji wskazanych powyżej.</li>
   </ol>
  </li>
  <li>Zleceniobiorca upoważnia Zleceniodawcę do wykonywania autorskich praw osobistych w stosunku do przedmiotu zlecenia, w tym w szczególności zezwala na dokonywanie zmian, fragmentaryzacji, przeróbek, montażu oraz łączenia i ekstrakcji poszczególnych elementów lub fragmentów, jak również na łączenie z innymi utworami oraz do nie wskazywania imienia i nazwiska Zleceniobiorcy podczas korzystania i rozporządzania przedmiotem zlecenia oraz do zmiany pierwotnego tytułu przedmiotu zlecenia lub jego części. Ponadto Zleceniobiorca zobowiązuje się do niewykonywania uprawnień określonych w art. 16 ustawy o prawie autorskim i prawach pokrewnych.</li>
  <li>W przypadku naruszenia przez Zleceniobiorcę postanowień ust. 2 niniejszego paragrafu będzie on zobowiązany do zapłaty kary umownej w wysokości 20 000,00 zł (słownie: dwadzieścia tysięcy złotych).</li>
</ol>
<br><br><br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 10 Informacje poufne</strong>
</p>
<ol>
  <li>Przez Informacje Poufne strony rozumieją wszelkie informacje przekazane Zleceniobiorcy przez Zleceniodawcę lub uzyskane przez Zleceniobiorcę w inny sposób w związku z wykonywaniem niniejszej umowy, obejmujące informacje techniczne, technologiczne, organizacyjne lub inne informacje posiadające wartość gospodarczą, które dotyczą Zleceniodawcy jego działalności i Klientów, a w szczególności materiały dydaktyczne wykorzystywane przez Zleceniodawcę, baza danych kontaktowych do Klientów Zleceniodawcy (w tym także klientów, którzy zakończyli współpracę ze Zleceniodawcą do 12 miesięcy po zakończeniu umowy), systemy komputerowe oraz pozostałe informacje uzyskiwane od Zleceniodawcy w trakcie wykonywania umowy.</li>
  <li>Zleceniobiorca zobowiązuje się, że Informacje Poufne uzyskane w ramach niniejszej umowy będą utrzymywane w tajemnicy przez Zleceniobiorcę i wykorzystywane wyłącznie do wykonania niniejszej umowy. Informacje Poufne nie będą wykorzystywane w innych celach ani nie będą ujawniane, czy udostępniane osobom trzecim, w całości lub w części. Zobowiązanie do zachowania poufności dotyczy Informacji Poufnych uzyskanych przez Zleceniobiorcę od Zleceniodawcy w formie pisemnej oraz ujawnionych Zleceniobiorcy ustnie, wizualnie, elektronicznie lub w inny sposób. Zleceniobiorca zobowiązuje się utrzymywać otrzymane Informacje Poufne w tajemnicy i nie ujawniać ich komukolwiek bez pisemnej zgody Zleceniodawcy.</li>
  <li>Zleceniobiorca, po zakończeniu współpracy Stron, bądź też, przed jej zakończeniem – na każde żądanie Zleceniodawcy - zobowiązany będzie zwrócić Zleceniodawcy w ciągu 3 dni wszelkie Informacje Poufne, wraz z dokumentacją i innymi nośnikami, na których zostały one utrwalone, jak również, kopiami dokumentacji lub nośników zawierających takie Informacje. Zleceniobiorca zobowiązuje się do usunięcia z pamięci komputerów oraz innych urządzeń wszystkich otrzymanych lub wykonanych materiałów w sposób uniemożliwiający ich odtworzenie oraz wykorzystywanie w przyszłości w jakiejkolwiek formie.</li>
  <li>W przypadku naruszenia przez Zleceniobiorcę postanowień ustępów poprzedzających, w szczególności, poprzez niezgodne z tą umową ujawnienie lub udostępnienie materiałów oraz Informacji Poufnych, Zleceniobiorca zobowiązany będzie do zapłaty na rzecz Zleceniodawcy kary umownej w wysokości 5 000,00 zł (słownie: pięć tysięcy złotych) za każde takie naruszenie. Kara taka płatna będzie w terminie 14 dni od daty złożenia przez Zleceniodawcę oświadczenia o obciążeniu Zleceniobiorcy karą umową.</li>
  <li>Jeżeli wysokość szkody lub utraconych korzyści Zleceniodawcy wynikających z naruszenia przez Zleceniobiorcę postanowień niniejszej umowy przewyższać będzie wysokość kary umownej wskazanej w ust. 4 niniejszego paragrafu, Zleceniodawca może dochodzić odszkodowania uzupełniającego na zasadach ogólnych wynikających z Kodeksu cywilnego.</li>
  <li>Za naruszenie zasad opisanych w niniejszej umowie, Zleceniodawca uznaje także każdorazowe wykorzystanie materiałów dydaktycznych Zleceniodawcy do prywatnych celów Zleceniobiorcy oraz do celów nauczania osób, które nie są Klientami Zleceniodawcy.</li>
  <li>Niezależnie od wygaśnięcia czy rozwiązania niniejszej umowy, zobowiązania Zleceniobiorcy zachowania w poufności Informacji Poufnych pozostają w mocy przez okres 5 lat.</li>
</ol>

<p align="center" style="margin-bottom: 0px;">
      <strong>§ 11 Zakaz konkurencji</strong>
    </p>
    <ol>
      <li>
        Zleceniobiorca jest zobowiązany do powstrzymania się od podejmowania i wykonywania działalności konkurencyjnej wobec Zleceniodawcy, w czasie obowiązywania niniejszej Umowy - zgodnie z definicją opisaną w niniejszym paragrafie.
        </li>
        <li>
          Postanowienia dotyczące zakazu konkurencji, Strony określają szczegółowo w dalszej części niniejszego paragrafu. 
      </li>
      <li>
        Za działalność konkurencyjną w rozumieniu niniejszego paragrafu Strony uznają oferowanie lub świadczenie przez Zleceniobiorcę, na jakiejkolwiek podstawie lub formie, usług edukacyjnych podobnych do usług oferowanych przez Zleceniodawcę, na rzecz klientów Zleceniodawcy, którzy zawarli ze Zleceniodawcą umowę najpóźniej w dniu wygaśnięcia albo rozwiązania niniejszej umowy.
      </li>
      <li>
        Za działalność konkurencyjną uznaje się również:
        <ol type="a">
          <li>
            świadczenie przez Zleceniobiorcę pracy na rzecz podmiotu prowadzącego działalność konkurencyjną wobec Zleceniodawcy (zgodnie z definicją zawartą w ust. 5 niniejszego paragrafu), w tym świadczenie usług na rzecz takich podmiotów na podstawie jakiejkolwiek innej umowy cywilnoprawnej,
          </li>
          <li>
            prowadzenie przez Zleceniobiorcę działalności konkurencyjnej, zgodnie z definicją opisaną w ust. 3, wobec Zleceniodawcy, także za pośrednictwem osób trzecich,
          </li>
          <li>
            bycie wspólnikiem lub członkiem organów spółki prowadzącej działalność konkurencyjną wobec Zleceniodawcy, zgodnie z definicją opisaną w ust. 5,
          </li>
          <li>
            pełnienie funkcji agenta, pełnomocnika lub prokurenta w podmiotach prowadzących działalność konkurencyjną wobec Zleceniodawcy, zgodnie z definicją opisaną w ust. 5.
          </li>
        </ol>
      </li>
      <li>
        Za podmiot prowadzący działalność konkurencyjną wobec Zleceniodawcy uznaje się każdy podmiot, który prowadzi działalność o tożsamym  charakterze do działalności prowadzonej przez Zleceniodawcę, wykorzystując te same lub podobne technologie, które nie są ogólnodostępne (tj. nie są powszechnie znane), oraz działa w oparciu o zbliżony model biznesowy do modelu Zleceniodawcy. Konkurencyjność tych podmiotów polega na tym, że oferują one usługi lub produkty edukacyjne, które mogą być bezpośrednią alternatywą dla usług oferowanych przez Zleceniodawcę, lub mają na celu pozyskanie tych samych klientów, korzystając z podobnych technologii i struktur organizacyjnych.
      </li>
      <li>
        Zleceniobiorca zobowiązuje się, że po wygaśnięciu albo rozwiązaniu niniejszej umowy nie będzie wykorzystywał materiałów, które zostały udostępnione mu przez Zleceniodawcę w trakcie współpracy.
      </li>
      <li>
        W przypadku, gdy w czasie obowiązywania niniejszej Umowy klient Zleceniodawcy złoży Zleceniobiorcy propozycję współpracy, Zleceniobiorca zobowiązany jest poinformować klienta o obowiązującym go zakazie konkurencji i odmówić podjęcia współpracy. Zleceniobiorca ma również obowiązek niezwłocznie poinformować Zleceniodawcę o zaistniałej sytuacji.
      </li>
      <li>
        Zleceniodawca zastrzega sobie prawo do weryfikacji przestrzegania przez Zleceniobiorcę postanowień niniejszego paragrafu.
      </li>
      <li>
        W przypadku naruszenia zakazu konkurencji, Zleceniobiorca zobowiązany jest do zapłaty Zleceniodawcy kary umownej w wysokości 20 000,00 zł (słownie: dwadzieścia tysięcy złotych) za każdy przypadek naruszenia. Zleceniodawcy przysługuje również prawo do dochodzenia odszkodowania na zasadach ogólnych, w wysokości przewyższającej zapłaconą karę umowną.
      </li>
    </ol>
    <br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 12 Doręczenia i korespondencja, zgoda na wykorzystanie wizerunku, RODO</strong>
</p>
<ol>
  <li>Strony postanawiają, że o ile nie dojdzie do pisemnego powiadomienia o zmianie adresu do korespondencji wszelka korespondencja kierowana na adresy podane w oznaczeniu stron, uważa się za doręczone najpóźniej z datą drugiego awizo.</li>
  <li>Adresy poczty elektronicznej podane są w oznaczeniu stron. Pismo wysłane drogą elektroniczną uważa się za doręczone z chwilą, gdy druga strona miała możliwość zapoznania się z nim.</li>
  <li>Zleceniobiorca wyraża zgodę na wykorzystanie swojego wizerunku, zgodnie z załącznikiem do niniejszej umowy.</li>
  <li>Zleceniobiorca zobowiązany jest do stosowania się do przepisów Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (RODO) oraz Ustawy z dnia 10 maja 2018 r. o ochronie danych osobowych (t.j. Dz. U. z 2019 r. poz. 1781 z późn. zm). Zleceniobiorca wyraża zgodę na przetwarzanie jego danych osobowych, zgodnie z klauzulą informacyjną stanowiącą załącznik do niniejszej umowy.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px;">
    <strong>§ 13 Standardy ochrony małoletnich</strong>
  </p>
  <p>Zleceniobiorca oświadcza, iż zapoznał się z zapisami dokumentu „Standardy ochrony małoletnich w Tutore Poland Sp. z o.o.” wprowadzonego przez Zleceniodawcę na mocy  ustawy z dnia 13 maja 2024 r. o ochronie małoletnich (Dz.U. 2024 poz. 560) i zobowiązuje się do jej przestrzegania. Naruszenie postanowień regulaminu będzie uznawane za istotne naruszenie obowiązków wynikających z niniejszej umowy i może skutkować jej natychmiastowym rozwiązaniem.</p>
  <br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 14 Spory i sąd właściwy</strong>
</p>
<p>Strony oświadczają, że dołożą wszelkich starań by spory wynikłe z niniejszej umowy rozwiązać polubownie. W przypadku sporów, które nie będą mogły zostać rozwiązane polubownie w ciągu 14 dni od daty otrzymania przez drugą stronę pisemnego wezwania do takiego polubownego rozwiązania, zostaną one poddane pod rozstrzygnięcie sądowi właściwemu ze względu na siedzibę Zleceniodawcy.</p>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 15 Kompletność oraz zmiana umowy</strong>
</p>
<ol>
  <li>Niniejsza umowa rozwiązuje i zastępuje wszelkie inne dotychczasowe pisemne lub ustne ustalenia, porozumienia, uzgodnienia i umowy Stron w zakresie objętym jej treścią, które niniejszym tracą moc prawną.</li>
  <li>Strony oświadczają, że poza niniejszą umową nie istnieją między nimi żadne dodatkowe ustalenia czy porozumienia dotyczące przedmiotu niniejszej umowy.</li>
  <li>Wszelkie zmiany niniejszej umowy wymagają formy pisemnej pod rygorem nieważności.</li>
  <li>Rozwiązanie niniejszej umowy wymaga formy pisemnej pod rygorem nieważności.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 16 Klauzula salwatoryjna</strong>
</p>
<p>
  Jeżeli którekolwiek z postanowień niniejszej umowy okaże się nieważne w całości lub w części, pozostałe postanowienia pozostają w mocy, Strony zaś zobowiązują się na wniosek którejkolwiek z nich do zastąpienia nieważnych postanowień postanowieniami, których moc prawna i skutek ekonomiczny są najbardziej zbliżone do postanowień zastępowanych.
</p>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 17 Prawo właściwe</strong>
</p>
<ol>
  <li>Niniejsza umowa podlega prawu polskiemu.
</li>
  <li>W sprawach nieuregulowanych niniejszą umową zastosowanie mają właściwe przepisy prawa, w szczególności przepisy Kodeksu cywilnego.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 18 Liczba egzemplarzy umowy</strong>
</p>
<p>Niniejsza umowa została sporządzona w dwóch jednobrzmiących egzemplarzach, po jednym dla każdej ze stron.</p>
<br>

<div>
  <p class="underline">Załączniki:</p>
  <ol>
    <li class="underline">Zgoda na wykorzystanie wizerunku</li>
    <li class="underline">Klauzula informacyjna RODO</li>
    <li class="underline">Upoważnienie do przetwarzania danych osobowych</li>
    <li class="underline">Informacja o monitoringu zajęć on - line</li>
    <li class="underline">Oświadczenie Zleceniobiorcy</li>
    <li class="underline">Ogólne zasady bhp przy pracy administracyjno-biurowej</li>    
    <li class="underline">Miesięczny Arkusz Materiałów - wzór</li>
    <li class="underline">Kodeks Etyki</li>
  </ol>
</div>

<div class="cointainer" style="margin-top: 30px;">
    <div class="left-cointainer">
        <span style="margin-left: 0%;"><strong>{{zamawiajacy}} - <span v-if="zamawiajacy.includes('Ewa Szcześniewska')">pełnomocnik</span></strong></span><br>
        <span style="margin-left: 0%;">Podpis Zleceniodawcy</span>
    </div>
    <div class="right-cointainer">
        {{imieNazwisko}}<br>
        <span style="margin-left: 0%;">Podpis Zleceniobiorcy</span>
    </div>
</div>
<br><br>

 <div style="margin-top:5px;page-break-before: always;">
   <p><strong>Załącznik nr 1. ZGODA NA WYKORZYSTANIE WIZERUNKU</strong></p>
   <p>Niniejszym oświadczam, że udzielam Tutore Poland Sp. z o.o., z siedzibą w Łodzi przy ul. Piotrkowska 157A, 90-440, KRS 0000670834, NIP: 727-28-12-193, REGON: 366891567, (dalej: Tutore Poland Sp. z o.o.) zgody, na nieodpłatne utrwalenie oraz nieograniczone czasowo i terytorialnie wielokrotne wykorzystanie i rozpowszechnianie mojego wizerunku w formie fotografii w związku z wykonywaniem umowy zlecenia w celu</p>
   <p>Jak również niniejszym oświadczam, że udzielam Tutore Poland Sp. z o.o. zgody, na nieodpłatne utrwalenie oraz nieograniczone czasowo i terytorialnie wielokrotne wykorzystanie i rozpowszechnianie mojego głosu lub wypowiedzi utrwalonych w trakcie wykonywania niniejszej umowy o świadczenie usług przy użyciu telefonów o połączeniu VoIP (Voice over Internet Protocol).</p>
   <p>Niniejsza zgoda obejmuje następujące pola eksploatacji: wykorzystanie, utrwalanie, obróbkę i powielanie wykonanych zdjęć/nagrań, obrót egzemplarzami, na których utrwalono mój wizerunek lub głos oraz na zwielokrotnianie wizerunku/głosu wszelkimi dostępnymi technikami i metodami, rozpowszechnianie oraz publikowanie, w materiałach służących działalności Tutore Poland w szczególności w materiałach szkoleniowych, edukacyjnych i promocyjnych w dowolnej formie.</p>
   <p>Tutore Poland Sp. z o.o. przysługuje wyłączne prawo decydowania o formie i czasie wykorzystywania mojego wizerunku, głosu, wypowiedzi w całości lub w postaci dowolnych fragmentów. Wizerunek może być użyty do różnego rodzaju form elektronicznego przetwarzania obrazu, kadrowania i kompozycji, bez obowiązku akceptacji produktu końcowego, lecz nie w formach obraźliwych lub ogólnie uznanych za nieetyczne.</p>

   <div class="container" style="page-break-before: always;">
      <table style="border: 1px solid; text-align: left; font-size: 12px; width: 100%;">
        <tr>
          <td id="oswiadczenie">
            <p align="center" class="subheading"><strong>OŚWIADCZENIE ZLECENIOBIORCY</strong></p>
            <ol>
              <li>Ja niżej podpisany/a oświadczam, iż:
                <ol type="a">
                  <li>
                    zapoznałem/am się z Informacją o monitoringu zajęć on – line i nagrywaniu szkoleń wewnętrznych on - line oraz Klauzulą informacyjną i przyjmuję ją do wiadomości,
                  </li>
                  <li>
                    treść Informacji i Klauzuli jest dla mnie zrozumiała i jasna, a wszelkie wątpliwości zostały mi wyjaśnione przez osobę upoważnioną w sposób wyczerpujący. 
                  </li>
                </ol>
              </li>
              <li>
                W sposób całkowicie dobrowolny, wyrażam zgodę na przetwarzanie moich danych osobowych w celach wskazanych w Informacji o monitoringu zajęć on – line i nagrywaniu szkoleń wewnętrznych on – line.
              </li>
              <li>
                Zostałem/am poinformowany/a, że moje dane osobowe przetwarzane są na podstawie wyrażonej przeze mnie dobrowolnej zgody oraz, że przysługuje mi prawo do jej cofnięcia w każdym czasie, przy czym cofnięcie zgody wywołuje skutki prawne od momentu jego złożenia i będzie pozostawało bez wpływu na przetwarzanie moich danych osobowych dla celów związanych z realizacją badania przed złożeniem oświadczenia o cofnięciu zgody. 
              </li>
              <li>
                W trybie art. 81 ust.1 ustawy o prawie autorskim i prawach pokrewnych wyrażam zgodę na rozpowszechnianie mojego wizerunku przez Tutore Poland Sp. z o.o. w celach wskazanych w Informacji o monitoringu zajęć on – line i nagrywaniu szkoleń wewnętrznych on – line.
              </li>
            </ol>
            <div class="right-cointainer" style="float: right; margin-top: 20px;">
              <span style="font-size: 14px;">{{ imieNazwisko }}</span>
              <br>
              <span>czytelny podpis Zleceniobiorcy</span>
            </div>
          </td>
        </tr>
      </table>
    </div>
   <div style="page-break-before: always;">
  <p><strong>Załącznik nr 2. KLAUZULA INFORMACYJNA</strong></p>
  <p>Klauzule informacyjne z art. 13 RODO</p>
  <p> Zgodnie z art. 13 ust. 1 i 2 rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie danych) (Dz. Urz. UE L 119 z 04.05.2016, str. 1), dalej „RODO”, informuję, że:</p>
  <p>Administratorem Pani/Pana danych osobowych jest Tutore Poland Sp. z o.o., z siedzibą w Łodzi przy ul. Piotrkowska 157A, 90-440, KRS 0000670834, zwany dalej: „ADO”.</p>
  <p>Może Pan/Pani kontaktować się z ADO pisząc na adres: Tutore Poland Sp. z o.o, ul. Piotrkowska 157A, 90-440, mail kadry@tutore.eu oraz poprzez kontakt z Inspektorem Ochrony Danych na adres e-mail: mlokaj@mlkancelaria.com</p>
  <p>ADO przetwarza dane osobowe w celu:</p>
  <ol type="a">
    <li>nawiązania współpracy - Art. 6 ust. 1 lit. b, f RODO,</li>
    <li>zapewnienia kontaktu pomiędzy Stronami (adres  e – mail, nr telefonu) - Art. 6 ust. 1 lit. b, f RODO,</li>
    <li>realizacji praw i obowiązków wynikających z umowy o świadczenie usług - Art. 6 ust. 1 lit. b, c, f RODO,</li>
    <li>prowadzenia rejestru korespondencji - Art. 6 ust. 1 lit. c, f RODO,</li>
    <li>ewidencji przebiegu współpracy (w tym realizacja płatności) - Art. 6 ust. 1 lit. b, c RODO,</li>
    <li>dochodzenia roszczeń i praw - Art. 6 ust. 1 lit. b, f RODO,</li>
    <li>realizacji obowiązków podatkowych - Art. 6 ust. 1 lit. b, c RODO,</li>
  </ol>
  <br>
  <p>Odbiorcami danych osobowych są podmioty, którym ADO powierzył przetwarzanie danych osobowych, w szczególności: dostawcy usług technicznych i organizacyjnych, dostawcy usług księgowych, kadrowych, prawnych i doradczych, banki (realizacja płatności), organy publiczne w ramach realizacji obowiązków związanych z prowadzeniem działalności gospodarczej przez ADO. </p>
  <p>ADO nie przekazuje danych osobowych poza Europejski Obszar Gospodarczy.</p>
  <p>Dane osobowe przechowywane będą przez okres realizacji umowy, a następnie przez okres wyznaczony przez powszechnie obowiązujące przepisy prawa, w tym w szczególności: dochodzenie roszczeń (okres przedawnienia roszczeń), prowadzenie ksiąg rachunkowych i dokumentacji podatkowej (5 lat od końca roku kalendarzowego, w którym powstał obowiązek podatkowy).</p>
  <p>Osoba, której dane są przetwarzane ma prawo dostępu do swoich danych oraz otrzymania ich kopii, prawo do sprostowania (poprawiania) swoich danych, prawo do usunięcia danych, prawo do cofnięcia zgody, prawo do ograniczenia przetwarzania, prawo do bycia zapomnianym, prawo do sprzeciwu, prawo do przenoszenia danych, prawo do wniesienia skargi do Urzędu Ochrony Danych Osobowych.</p>
  <p>Podanie przez Panią/Pana danych osobowych oraz zgoda na ich przetwarzanie i rozpowszechnianie wizerunku jest dobrowolne, ale stanowi warunek konieczny dla nawiązania współpracy i ewentualnego zawarcia umowy w formie pisemnej oraz realizacji praw i obowiązków przez ADO.</p>
  <p>W ramach działalności ADO nie dochodzi do zautomatyzowanego podejmowania decyzji, w tym profilowania, z wykorzystaniem zebranych danych osobowych.</p>
  <p>Zakres danych podlegający przetwarzaniu: imię i nazwisko, adres mailowy, numer telefonu, wizerunek, PESEL.</p>
  <p style="margin-top: 75px;">{{imieNazwisko}}</p>
  <p>Podpis Zleceniobiorcy</p>
  </div>
  </div>

<div style="page-break-before: always;">
  <div class="cointainer" style="margin-top: 60px;">
    <div class="left-cointainer">
      <p><em>Załącznik nr 3 Upoważnienie do przetwarzania danych osobowych</em></p>
    </div>
    <div class="right-cointainer">
      <p style="margin-bottom: 10px; font-size: 14px;">
    Łódź, dnia {{ aktualnaData() }} r.
      </p>
    </div>
</div>
  
  
<p align="center" class="subheading" style="margin-bottom: 10px;">
  <strong>
    Upoważnienie do przetwarzania danych osobowych w zbiorze w wersji<br>papierowej i elektronicznej 
  </strong>
</p>
<p class="p-margin">
  Na podstawie art. 29 Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie danych), dalej RODO, niniejszym:
</p>
<p class="p-margin">
  z dniem podpisania upoważnienia przez obie strony
</p>
<p class="p-margin">
  upoważniam Pana/Panią {{ imieNazwisko }} Zleceniobiorcę Tutore Poland Sp. z o.o.
</p>
<p class="p-margin">
  do przetwarzania danych osobowych zawartych w poniżej wymienionych zbiorach danych osobowych:
</p>
  <ol type="a">
    <li>w wersji elektronicznej:
      <ul>
        <li>
          zbiór danych osobowych Klientów: rodziców (opiekunów prawnych) dzieci, młodzieży i dorosłych korzystających z usług oferowanych przez Tutore Poland – imię i nazwisko, adres zamieszkania, telefon kontaktowy, adres e-mail,
        </li>
        <li>
          zbiór danych osobowych Klientów: dzieci, młodzieży i dorosłych korzystających z usług oferowanych przez Tutore Poland– imię i nazwisko, adres zamieszkania, telefon kontaktowy, adres e-mail.
        </li>
      </ul>
    </li>
  </ol>
<p class="p-margin">
  w zakresie wglądu, wprowadzania, modyfikacji, usuwania i archiwizacji danych osobowych objętych wyżej wymienionymi zbiorami.
</p>
<p class="p-margin">
  Niniejsze upoważnienie nie upoważnia do udzielania dalszych upoważnień i wygasa z dniem ustania umowy zlecenia, a ponadto może być w każdym czasie zmienione lub odwołane.
</p>
<p>
  Zobowiązuję Pana/Panią do przetwarzania danych osobowych zawartych w ww. zbiorach danych osobowych w zakresie i w sposób wymagany do wypełnienia obowiązków służbowych względem Zleceniodawcy - Administratora Danych Osobowych. Zobowiązuję Pana/Panią do przetwarzania danych osobowych zgodnie z udzielonym upoważnieniem, rozporządzeniem Parlamentu Europejskiego i Rady (UE)2016/679 z 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE ( Dz. Urz. UE L 119, s.1) oraz przepisami ustawy z dnia 10 maja 2018 r. o ochronie danych osobowych (Dz.U. z 2018 r. poz.1000) i obowiązującymi w Tutore Poland Sp. z o.o. wewnętrznymi regulacjami w sprawie ochrony danych osobowych.
  <br>
  Naruszenie ww. obowiązków może skutkować poniesieniem odpowiedzialności karnej oraz stanowi podstawę do rozwiązania umowy zlecenie.
</p>

<div class="container" style="page-break-before: always;">
    <table style="border: 1px solid; text-align: left; font-size: 12px; width: 100%;">
      <tr>
        <td id="oswiadczenie">
          <p align="center" class="subheading"><strong>OŚWIADCZENIE ZLECENIOBIORCY</strong></p>
          <ol>
        <li>Ja niżej podpisany/a oświadczam, iż:
        <ol type="a">
          <li>
            zapoznałem/am się z treścią i zakresem upoważnienia i przyjmuję je do wiadomości, 
          </li>
          <li>
            treść upoważnienia jest dla mnie zrozumiała i jasna, a wszelkie wątpliwości zostały mi wyjaśnione przez osobę upoważnioną w sposób wyczerpujący,
          </li>
          <li>
            zobowiązuję się do przetwarzania danych osobowych zawartych w ww. zbiorach danych osobowych w zakresie i w sposób wymagany do wypełnienia obowiązków służbowych względem Zleceniodawcy,
          </li>
          <li>
            zobowiązuję się do przetwarzania danych osobowych zgodnie z udzielonym upoważnieniem, przepisami Rodo oraz wewnętrznymi procedurami obowiązującymi u Zleceniodawcy, w tym Polityką Prywatności,
          </li>
          <li>
            zobowiązuję się do zachowania w tajemnicy danych osobowych, do których mam lub będę miał dostęp w związku z wykonywaniem obowiązków na rzecz Tutore Poland Sp. z o.o. oraz zachowania w tajemnicy sposobów zabezpieczenia danych osobowych, również po odwołaniu lub zmianie upoważnienia, a także po zakończeniu trwania umowy zlecenie.
          </li>
        </ol>
        </li>
        </ol>
          <div class="right-cointainer" style="float: right; margin-top: 20px;">
        <span style="font-size: 14px;">{{imieNazwisko}}</span>
        <br>
        <span>czytelny podpis Zleceniobiorcy</span>
        </div>
      </td>
    </tr>
  </table>
  </div>

<p class="subheading p-margin" style="text-align: center;">
  {{ zamawiajacy }} 
  <br>
  <strong>w imieniu Administratora</strong>
</p>
<br>
<p>Niniejsze upoważnienie uchylone zostało w dniu rozwiązania umowy zlecenie.</p>
</div>

<div style="page-break-before: always;">
  <p><em>Załącznik nr 4</em></p>
  <p class="subheading" style="margin-bottom: 0px;"><strong>Informacja o monitoringu zajęć on – line i nagrywaniu szkoleń wewnętrznych on - line</strong></p>
  <br>
  nformujemy, iż Tutore Poland Sp. z o.o. korzysta z środków technicznych umożliwiających monitoring prowadzonych zajęć on – line oraz nagrywania szkoleń wewnętrznych on - line. Monitoringiem są objęte urządzenia rejestrujące obraz oraz dźwięk, z których korzysta użytkownik w celu realizacji zajęć online tj. platforma Clickmeeting bądź aplikacja Zoom, a w przypadku szkoleń wewnętrznych online aplikacja Zoom. Tutore Poland Sp. z o.o. stosuje monitoring w następujących celach: zapewnienia najwyższych standardów obsługi zajęć lekcyjnych realizowanych przez pracowników/zleceniobiorców, prawidłowości wykonywania powierzonych czynności oraz ewentualnego poprawienia jakości lekcji, zabezpieczenia interesów firmy w sytuacjach spornych z klientem (materiał dowodowy), a w przypadku szkoleń wewnętrznych on – line w celu zapewnienia możliwości udostępnienia nagrań nowym pracownikom/zleceniobiorcom. Informujemy, iż: system monitoringu audiowizualnego i dźwiękowego zajęć online składa się z systemu rejestrującego platformy Clickmeeting bądź Zoom oraz serwera, na którym są zapisywane zajęcia online, dostęp do zapisu nagrań zajęć online posiadają osoby upoważnione przez Zarząd Tutore Poland Sp. z o.o. tj. Manager Działu Call Center, Dyrektor ds. Zarządzania Procesami, Teamleader Działu Infolinii, osoby, które mają wgląd do zarejestrowanego obrazu mają świadomość odpowiedzialności za ochronę danych osobowych oraz posiadają stosowne upoważnienie wydane przez Administratora danych osobowych. W toku nagrania dochodzi do przetwarzania danych osobowych w postaci głosu, wizerunku oraz imienia i nazwiska pracownika/zleceniobiorcy prowadzącego zajęcia lub szkolenie. Administratorem danych osobowych uzyskanych w ramach monitoringu zajęć on – line i w toku nagrywania szkoleń wewnętrznych on - line jest Tutore Poland Sp. z o.o., który w związku z opisaną powyżej czynnością zamieszcza poniżej wymaganą klauzulę informacyjną dotyczącą przetwarzania danych osobowych.

  <p style="margin-top: 75px;"><strong>Podpis Zleceniobiorcy</strong></p>
  <p>{{imieNazwisko}}</p>
</div>

<div style="margin-top:40px; page-break-before: always; font-size: 10px;">
  <p align="right" style="font-size: 14px; margin-bottom: 0;">
        Łódź, dnia {{ aktualnaData() }} r.
      </p>
        <p style="font-size: 14px; margin-bottom: 0;">{{imieNazwisko}}</p>
        <p style="font-size: 14px;">Imię i nazwisko Zleceniobiorcy</p>
<p align="center" class="subheading">
  <strong>INFORMACJA O PRZETWARZANIU DANYCH OSOBOWYCH</strong>
</p>
  <ol>
    <li>
      Informuję, że Administratorem danych osobowych Pani/Pana jako Zleceniobiorcy jest Tutore Poland Sp. z
      o.o. z siedzibą przy ul. Piotrkowska 157A, 90-440 Łódź, KRS: 0000670834, NIP:
      7272812193, tel. 500 965 135, info@tutore.eu
    </li>
    <li>
      Przedstawiając Pani/Panu niniejszą informację o przetwarzaniu danych osobowych Administrator spełnia
      obowiązek prawny wynikający z art. 15 ust. 1 Rozporządzenia Parlamentu Europejskiego i Rady (UE)
      2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem
      danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE
      (ogólne rozporządzenie o ochronie danych), dalej RODO.
    </li>
    <li>
      Administrator pozyskuje informacje o Pani/Panu w związku z obowiązkiem ustawowym, co jest niezbędne do
      skutecznej realizacji procesu współpracy. W zakresie danych osobowych nie dotkniętych ustawowym
      warunkiem niezbędności – ich podanie jest dobrowolne.
    </li>
    <li>
      Pani/Pana dane osobowe przetwarzane są w następujących celach, na następującej podstawie i w
      następującym okresie:
      <ol type="a">
        <li>
          zawarcia oraz realizacji umowy cywilnoprawnej – w celu realizacji obowiązku wynikającego z kodeksu
          cywilnego (art. 6 ust. 1 lit. b, c, f RODO) – przez okres współpracy,
        </li>
        <li>
          wyliczenia i wypłaty wynagrodzenia – w celu realizacji obowiązku wynikającego z kodeksu cywilnego
          (art. 6 ust. 1 lit. c, art. 9 ust. 2 lit. b RODO) – przez okres współpracy,
        </li>
        <li>
          potrąceń z wynagrodzenia – w celu realizacji obowiązków w zakresie egzekucji z wynagrodzenia
          wynikających z kodeksu postępowania cywilnego, ustawy o postępowaniu egzekucyjnym w administracji,
          ustawy o komornikach sądowych (art. 6 ust. 1 lit. c RODO) – przez okres wyznaczony przez
          powszechnie obowiązujące przepisy prawa,
        </li>
        <li>
          realizacji obowiązków podatkowych – w celu realizacji obowiązków płatnika podatku dochodowego
          wynikających z ordynacji podatkowej, ustawy o podatku dochodowym od osób fizycznych i innych
          przepisów podatkowych (art. 6 ust. 1 lit. c RODO) – przez okres 5 lat od końca roku
          kalendarzowego,
        </li>
        <li>
          realizacji obowiązków wobec ZUS – w celu realizacji obowiązków płatnika składek na ubezpieczenie
          społeczne i zdrowotne wynikających z ustawy o emeryturach i rentach z Funduszu Ubezpieczeń
          Społecznych, ustawy o systemie ubezpieczeń społecznych oraz ustawy o świadczeniach opieki
          zdrowotnej finansowanych ze środków publicznych (art. 6 ust. 1 lit. c, art. 9 ust. 2 lit b RODO) –
          przez okres 5 lat od końca roku kalendarzowego,
        </li>
        <li>
          realizacji obowiązków księgowych – w celu realizacji obowiązków wynikających z ustawy o
          rachunkowości, ordynacji podatkowej oraz ustawy o podatku dochodowym od osób prawnych (art. 6 ust.
          1 lit. c RODO) – przez okres 5 lat od końca roku rozliczeniowego, w którym nastąpiło zdarzenie,
        </li>
        <li>
          bezpieczeństwa fizycznego budynków, pomieszczeń oraz mienia Administratora – na podstawie prawnie
          uzasadnionego interesu Administratora (art. 6 ust. 1 lit. f RODO) – przez okres współpracy,
        </li>
        <li>
          zapewnienia najwyższych standardów obsługi zajęć lekcyjnych realizowanych przez Współpracowników
          za pośrednictwem platformy ClickMeeting lub Zoom, prawidłowości wykonywania powierzonych czynności
          oraz ewentualnego poprawienia jakości lekcji, zabezpieczenia interesów firmy w sytuacjach spornych
          z klientem (materiał dowodowy) poprzez monitoring i nagrywanie kursów online – na podstawie
          dobrowolnej zgody nagrywanego (art. 6 ust. 1 lit. a RODO) – Wizerunek i głos Współpracownika
          będzie przetwarzany przez okres 3 miesięcy. W przypadku, w którym nagrania zarejestrowanych zajęć
          stanowią dowód w postępowaniu prowadzonym na podstawie przepisów prawa lub Administrator powziął
          wiadomość, iż mogą one stanowić dowód w postępowaniu, termin ten ulega przedłużeniu do czasu
          prawomocnego zakończenia postępowania. Po upływie tych okresów nagrania zawierające dane osobowe,
          podlegają zniszczeniu,
        </li>
        <li>
          zapewnienia możliwości udostępnienia nagrań nowym Pracownikom i Współpracownikom nagrywanie
          szkoleń online prowadzonych za pomocą platformy Zoom – na podstawie dobrowolnej zgody nagrywanego
          (art. 6 ust. 1 lit. a RODO) - Wizerunek i głos Współpracownika będą przetwarzane do czasu
          wycofania zgody. W razie wycofania zgody nagrania zawierające dane osobowe, podlegają zniszczeniu,
        </li>
        <li>
          zapewnienia najwyższych standardów jakości obsługi klienta, w celu szkoleniowym – umożliwiającym
          poprawienie jakości obsługi, zabezpieczenia interesów firmy w sytuacjach spornych z klientem
          (materiał dowodowy), zapewnienia bezpieczeństwa Współpracownikom w przypadku zdarzeń niepożądanych
          i niebezpiecznych ze strony Klientów (np. groźby karalne) poprzez monitoring rozmów telefonicznych
          z Klientami Administratora – na podstawie prawnie uzasadnionego interesu Administratora (art. 6
          ust. 1 lit. f RODO) - przez okres do 3 miesięcy. W przypadku, w którym nagrania zarejestrowanych
          rozmów telefonicznych stanowią dowód w postępowaniu prowadzonym na podstawie przepisów prawa lub
          Administrator powziął wiadomość, iż mogą one stanowić dowód w postępowaniu, termin ten ulega
          przedłużeniu do czasu prawomocnego zakończenia postępowania. Po upływie tych okresów nagrania
          zawierające dane osobowe, podlegają zniszczeniu,
        </li>
        <li>
          tworzenia fotorelacji z obozów dla dzieci i młodzieży na pendrive dla Klientów, fanpagu facebook i
          Witrynie internetowej www.musicandmore.pl – na podstawie dobrowolnej zgody nagrywanego (art. 6
          ust. 1 lit. a RODO) - Wizerunek i głos Współpracownika będą przetwarzane do czasu wycofania zgody.
          W razie wycofania zgody nagrania zawierające dane osobowe, podlegają zniszczeniu,
        </li>
        <li>
          dochodzenia roszczeń lub obrony przed roszczeniami – na podstawie prawnie uzasadnionego interesu
          Administratora (art. 6 ust. 1 lit. f RODO) polegającego na występowaniu w sprawach sądowych – w
          przypadku toczącego się postępowania przez okres trwania postępowania do czasu jego prawomocnego
          zakończenia oraz przez okres wyznaczony przez powszechnie obowiązujące przepisy prawa.
        </li>
      </ol>
    </li>
    <li>
      Odbiorcami Pani/Pana danych osobowych będą:
      <ul>
        <li>
          organy administracji publicznej (np. Zakład Ubezpieczeń Społecznych, Urzędy Skarbowe) – na mocy
          odpowiednich przepisów prawa;
        </li>
        <li>
          zakłady opieki zdrowotnej w celach związanych z medycyną pracy;
        </li>
        <li>
          podmioty zewnętrzne dostarczające i wspierające systemy teleinformatyczne Zleceniodawcy (zarówno
          ogólną infrastrukturę teleinformatyczną, pocztę elektroniczną, jak i systemy informatyczne
          stosowane przez Zleceniodawcę w celu obsługi kadrowo-finansowej lub obiegu dokumentów związanych z
          zatrudnieniem) – na mocy stosownych umów powierzenia przetwarzania danych osobowych oraz przy
          zapewnieniu stosowania przez ww. podmioty adekwatnych środków technicznych i organizacyjnych
          zapewniających ochronę danych,
        </li>
        <li>
          biura księgowe:
        </li>
        <li>
          banki – w celu wypłaty wynagrodzeń i innych świadczeń pieniężnych na rzecz Zleceniodawcy w
          przypadku ich wypłaty za zgodą Zleceniobiorcy na rachunek bankowy;
        </li>
        <li>
          kontrahenci – w celu umożliwienia kontrahentom (potencjalnym oraz obecnym) kontaktu lub w celu
          bieżącej realizacji zawartych umów, a związanych z zajmowanym przez Zleceniobiorcę stanowiskiem
          pracy;
        </li>
        <li>
          współpracownicy Zleceniodawcy, którzy świadczą usługi na rzecz Tutore Poland Sp. z o.o., w celu
          umożliwienia współpracownikom kontaktu ze Zleceniobiorcą,
        </li>
        <li>
          podmioty świadczące dodatkowe usługi dla Zleceniobiorców, wyłącznie w przypadku korzystania przez
          Zleceniobiorcę z tych usług.
        </li>
        <li>
          instytucje ubezpieczeniowe
        </li>
        <li>
          organizacje administracji zagranicznej w krajach UE, w których realizowana jest umowa (dotyczy
          realizacji umowy za granicą)
        </li>
        <li>
          podmioty szkoleniowe i realizujące obowiązki BHP (jeśli nie ma komórki BHP u Zleceniodawcy)
        </li>
      </ul>
    </li>
    <li>
      Ma Pani/Pan prawo do:
      <ol type="a">
        <li>
          <strong>dostępu do danych</strong> — uzyskania od Administratora potwierdzenia, czy przetwarzane
          są Pani/Pana dane osobowe. Jeżeli dane są przetwarzane, jest Pani/Pan uprawniona/y do uzyskania
          dostępu do nich (art. 15 RODO);
        </li>
        <li>
          <strong>otrzymania kopii danych</strong> — uzyskania kopii danych podlegających przetwarzaniu,
          przy czym pierwsza kopia jest bezpłatna, a za kolejne kopie właściwy Administrator może nałożyć
          opłatę w rozsądnej wysokości, wynikającą z kosztów administracyjnych (art. 15 ust. 3 RODO);
        </li>
        <li>
          <strong>sprostowania</strong> — żądania sprostowania danych osobowych, które są nieprawidłowe, lub
          uzupełnienia niekompletnych danych (art. 16 RODO);
        </li>
        <li>
          <strong>usunięcia danych</strong> — żądania usunięcia danych osobowych, jeżeli Administrator nie
          ma już podstawy prawnej do ich przetwarzania lub dane nie są już niezbędne do celów przetwarzania
          (art. 17 RODO);
        </li>
        <li>
          <strong>ograniczenia przetwarzania</strong> — żądania ograniczenia przetwarzania danych osobowych
          (art. 18 RODO), gdy:
          <ol type="i">
            <li>
              kwestionuje Pani/Pan prawidłowość danych osobowych — na okres pozwalający Administratorowi
              sprawdzić prawidłowość tych danych,
            </li>
            <li>
              przetwarzanie jest niezgodne z prawem, a sprzeciwia się Pani/Pan ich usunięciu, żądając
              ograniczenia ich wykorzystywania,
            </li>
            <li>
              Administrator nie potrzebuje już tych danych, ale są one Pani/Panu do ustalenia, dochodzenia
              lub obrony roszczeń;
            </li>
            <li>
              wniosła Pani/wniósł Pan sprzeciw wobec przetwarzania — do czasu stwierdzenia, czy prawnie
              uzasadnione podstawy po stronie Administratora są nadrzędne wobec podstaw Pani/Pana sprzeciwu;
            </li>
          </ol>
        </li>
        <li>
          <strong>przenoszenia danych</strong> — otrzymania w ustrukturyzowanym, powszechnie używanym
          formacie nadającym się do odczytu maszynowego danych osobowych Pani/Pana dotyczących dostarczonych
          Administratorowi, oraz żądania przesłania tych danych innemu Administratorowi, jeżeli dane są
          przetwarzane na podstawie Pani/Pana zgody, lub umowy z Panią/Panem zawartej oraz jeżeli dane są
          przetwarzane w sposób zautomatyzowany (art. 20 RODO);
        </li>
        <li>
          <strong>sprzeciwu</strong> — wniesienia sprzeciwu wobec przetwarzania danych osobowych w prawnie
          uzasadnionych celach Administratora, z przyczyn związanych z Pani/Pana szczególną sytuacją, w tym
          wobec profilowania. Administrator dokonuje oceny istnienia ważnych prawnie uzasadnionych podstaw
          do przetwarzania, nadrzędnych wobec Pani/Pana interesów, praw i wolności lub podstaw do ustalenia,
          dochodzenia lub obrony roszczeń. Jeżeli zgodnie z oceną Pani/Pana interesy będą ważniejsze od
          interesów Administratora, Administrator będzie zobowiązany zaprzestać przetwarzania danych w tych
          celach (art. 21 RODO);
        </li>
        <li>
          <strong>prawo wniesienia skargi do organu nadzorczego</strong> – Prezesa Urzędu Ochrony Danych
          Osobowych, gdy uzna Pani/Pan, iż przetwarzanie danych osobowych Pani/Pana dotyczących narusza
          przepisy. Skargi można składać w formie:
          <ul>
            <li>
              pisemnej na adres: ul. Stawki 2, 00-193 Warszawa,
            </li>
            <li>
              elektronicznie za pośrednictwem platformy ePUAP.
            </li>
          </ul>
        </li>
      </ol>
    </li>
    <li>
      W trakcie przetwarzania danych osobowych nie dochodzi do wyłącznie zautomatyzowanego podejmowania
      decyzji ani do profilowania, o których mowa w art. 22 ust. 1 i 4 RODO, co oznacza, że żadne decyzje
      Pani/Pana dotyczące nie będą zapadać automatycznie oraz że nie będą tworzone żadne profile Pani/Pana
      dotyczące.
    </li>
    <li>
      Ma Pani/Pan obowiązek informowania Zleceniodawcy o wszelkich zmianach dotyczących Pani/Pana danych
      osobowych, przekazanych Zleceniodawcy zgodnie z Umową.
    </li>
  </ol>
</div>

<div style="page-break-before: always;">
  <div class="container">
    <table style="border: 1px solid; text-align: left; font-size: 12px; width: 100%;">
      <tr>
        <td id="oswiadczenie">
          <p align="center" class="subheading"><strong>OŚWIADCZENIE ZLECENIOBIORCY</strong></p>
          <ol>
        <li>Ja niżej podpisany/a oświadczam, iż:
        <ol type="a">
          <li>zapoznałem/am się z Informacją o monitoringu zajęć on – line i nagrywaniu szkoleń wewnętrznych on - line oraz Klauzulą informacyjną i przyjmuję ją do wiadomości,</li>
          <li>treść Informacji i Klauzuli jest dla mnie zrozumiała i jasna, a wszelkie wątpliwości zostały mi wyjaśnione przez osobę upoważnioną w sposób wyczerpujący. </li>
          </ol>
          </li>
          <li>W sposób całkowicie dobrowolny, wyrażam zgodę na przetwarzanie moich danych osobowych w celach wskazanych w Informacji o monitoringu zajęć on – line i nagrywaniu szkoleń wewnętrznych on – line.</li>
          <li>Zostałem/am poinformowany/a, że moje dane osobowe przetwarzane są na podstawie wyrażonej przeze mnie dobrowolnej zgody oraz, że przysługuje mi prawo do jej cofnięcia w każdym czasie, przy czym cofnięcie zgody wywołuje skutki prawne od momentu jego złożenia i będzie pozostawało bez wpływu na przetwarzanie moich danych osobowych dla celów związanych z realizacją badania przed złożeniem oświadczenia o cofnięciu zgody.</li>
          <li>W trybie art. 81 ust.1 ustawy o prawie autorskim i prawach pokrewnych wyrażam zgodę na rozpowszechnianie mojego wizerunku przez Tutore Poland Sp. z o.o. w celach wskazanych w Informacji o monitoringu zajęć on – line i nagrywaniu szkoleń wewnętrznych on – line.</li>
          </ol>
          <div style="float: right; margin-top: 20px;">
        <span style="font-size: 14px;">{{imieNazwisko}}</span>
        <br>
        <span>czytelny podpis Zleceniobiorcy</span>
        </div>
      </td>
    </tr>
  </table>
  </div>
  </div>

    <div style="margin-top:5px;page-break-before: always;">
  <p><em>Załącznik nr 5 Oświadczenie Zleceniobiorcy</em></p>
  <p align="center" class="subheading"><strong>Oświadczenie Zleceniobiorcy</strong></p>

  <table style="border: 1px solid; text-align: left; font-size: 12px; width: 100%;">
  <tbody>

  <tr>
  <td style="border: 1px solid; background-color: #fff; text-align: center;">
  <p class="cell-in-first-table"><span><strong>DANE OSOBOWE</strong></span></p>
  </td>
  <td style="border: 1px solid; background-color: #fff; text-align: center;">
  <p class="cell-in-first-table"><span><strong>DO WYPEŁNIENIA</strong></span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Data</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{data}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Imiona i Nazwisko</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{imieNazwisko}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Numer PESEL</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{pesel}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Seria i numer dowodu osobistego (proszę podać w przypadku braku nr PESEL)</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{nrDowodu}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Obywatelstwo</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{obywatelstwo}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Numer telefonu</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{nrTelefonu}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Adres e-mail</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{email}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Adres zamieszkania</span><br><span class="caption"> (ulica, nr domu, kod pocztowy, miejscowość)</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table bigCell"><span>{{zamieszkany}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Adres korespondencyjny</span><br><span class="caption"> (ulica, nr domu, kod pocztowy, miejscowość)</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{korespondencyjny}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Urząd Skarbowy <br>(zgodny z adresem zamieszkania)</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table bigCell"><span>{{urzadSkarbowy}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Numer rachunku bankowego</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{nrRachunku}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid; background-color: #fff; text-align: center;">
  <p class="cell-in-first-table"><span><strong>OŚWIADCZAM, ŻE:</strong></span></p>
  </td>
  <td style="border: 1px solid; background-color: #fff; text-align: center;">
  <p class="cell-in-first-table"><span><strong>ODPOWIEDZI: „TAK” lub „NIE”<br>(lub opis, jeśli jest wymagany)</strong></span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>1. Jestem emerytem</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{emeryt}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>2. Jestem rencistą</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{rencista}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>3. Posiadam orzeczenie o stopniu niepełnosprawności</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{orzeczenieNiepelnosprawnosc}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>3.1. Jeśli wpisano "TAK", proszę określić orzeczony stopień niepełnosprawności</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{stopienNiepelnosprawnosc.replace(/\s*\(.*$/, '')}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>4. Jestem uczniem/studentem do 26 roku życia (nie dotyczy studiów doktoranckich, podyplomowych):</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{student}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>5. Wnoszę o dobrowolne ubezpieczenie chorobowe (tylko w przypadku objęcia obowiązkowym ubezpieczeniem emerytalnym i rentowym):</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{chorobowe.replace(/\s*\(.*$/, '')}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>6. Jestem zatrudniony/a na umowę o pracę lub umowę zlecenie w innym miejscu niż Tutore Poland Sp. z o.o.<br>(Jeśli wpisano "TAK", proszę uzupełnić poniższe dane)</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{zatrudnionyUmowaPraca.replace(/\s*\(.*$/, '')}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>6.1. Nazwa i adres pracodawcy/zleceniodawcy poza Tutore Poland Sp. z o.o. (proszę wypełnić w przypadku odpowiedzi TAK w pkt. 6):</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{nazwaUmowaPraca}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>6.2. Wynagrodzenie z tytułu umowy o pracę/umowy zlecenie w innym miejscu niż Tutore Poland Sp z o.o. jest wyższe bądź równe krajowej płacy minimalnej.<br></span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{wynagrodzenieUmowaPraca.replace(/\s*\(.*$/, '')}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>6.3. Wnoszę o dobrowolne ubezpieczenie emerytalne i rentowe (tylko w przypadku odpowiedzi TAK w pkt. 6 i 6.2):</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{wniosekUbezpieczenie}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>7. Podlegam ubezpieczeniu społecznemu z innego tytułu<br>niż umowa zlecenie z Tutore Poland Sp. z o.o. (np. zasiłek macierzyński, rodzicielski, urlop wychowawczy, własna pozarolnicza działalność gospodarcza):</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{ubezpieczenieUmowaPraca}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>7.1. W przypadku odpowiedzi: TAK, proszę określić tytuł ubezpieczenia</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{tytulUbezpieczenieUmowaPraca}}</span></p>
  </td>
  </tr>

<tr>
  <td colspan="2" style="border: 1px solid; background-color: #a4c2f4; text-align: center; font-size: 10px">
    <p class="cell-in-first-table oswiadczenie-footer">
      <strong>
      Wypełnienie powyższego oświadczenia oznacza zgodę na podanie Tutore Poland Sp. z o.o. numeru telefonu, e-mail i adresu do korespondencji, jak również oznacza deklarację zgodności wypisanych danych ze stanem prawnym oraz faktycznym, oraz świadomość odpowiedzialności karnej za zeznanie nieprawdy lub zatajenie prawdy.W przypadku zmiany ww. danych w trakcie trwania umowy zlecenie, zobowiązuję się do poinformowania Zleceniodawcy w terminie 7 dni od daty zaistnienia zmiany. Wszelkie szkody wynikające ze zmiany treści oświadczeń zobowiązuje się pokryć z własnych środków.
      </strong>
    </p>
    <p class="cell-in-first-table oswiadczenie-footer">
      <strong>
      Filling the above declaration means that you agree to provide Tutore Poland Sp. z o.o. phone number, e-mail and address for correspondence, as well as it means the declaration of compliance of the data with the legal and factual state, and awareness of criminal liability for telling untruth or concealing the truth.In case of above-mentioned data change during the term of the assignment, I undertake to inform the Principal within 7 days of the change occurring. I undertake to cover any damage resulting from a change in the content of the statements from my own resources.
      </strong>
    </p>
  </td>
</tr>

  </tbody>
  </table>
  </div>
    
<div style="margin-top: 5px;page-break-before: always;">
  <p><em><b>Załącznik nr 6</b></em></p>
  <p class="subheading" style="margin-bottom: 0px;"><strong>OGÓLNE ZASADY BHP PRZY PRACY ADMINISTRACYJNO-BIUROWEJ</strong></p>
  <br>
  <p>Bezpieczne warunki pracy są zapewnione, gdy:</p>
  <ul>
    <li>Zapewniona jest dostatecznie duża powierzchnia stanowiska pracy (co najmniej 2m wolnej powierzchni podłogi).</li>
    <li>Jest właściwe oświetlenie (w zależności od charakteru pracy min. 300lx).</li>
    <li>Jest dostateczna wentylacja pomieszczenia (naturalna lub mechaniczna); wilgotność względna powietrza nie powinna być mniejsza niż 40%.</li>
    <li>Jest wystarczające ogrzewanie w okresie jesienno-zimowym (min. +18°C)</li>
    <li>Są dostępne i w dobrym stanie urządzenia higieniczno-sanitarne oraz dobry stan techniczny mebli, sprzętu i innych urządzeń.</li>
  </ul>
  <p>Podstawowe czynności, które należy wykonać przed rozpoczęciem pracy:</p>
  <ul>
    <li>Zaplanować kolejność wykonywania poszczególnych czynności, przygotować potrzebne dokumenty i programy.</li>
    <li>Ustawić ekran monitora względem źródeł światła tak, aby ograniczyć olśnienie i odbicia światła.</li>
    <li>Sprawdzić stan techniczny mebli, sprzętu, urządzeń, stan oświetlenia stanowiska pracy.</li>
    <li>Zaznajomić się dokładnie z instrukcją obsługi i instrukcją bezpiecznej pracy sprzętu elektrycznego i elektronicznego używanego w trakcie wykonywania pracy (komputer, drukarka, itp.).</li>
    <li>Odpowiednio dla siebie dopasować krzesło i przygotować stanowisko pracy.</li>
  </ul>
  <p>Czynności, które należy wykonywać podczas pracy:</p>
    <ul>
    <li>Utrzymywać ład i porządek na stanowisku pracy.</li>
    <li>Zachowywać ostrożność przy używaniu urządzeń elektrycznych.</li>
  </ul>
  <p>Czynności zabronione:</p>
  <ul>
    <li>Dopuszczenia do użytkowania urządzeń osób nieupoważnionych.</li>
    <li>Otwierania osłon podczas pracy urządzeń.</li>
    <li>Używania niesprawnych bądź uszkodzonych urządzeń, względnie instalacji elektrycznej (np. zniszczona izolacja na przewodach, stłuczone wtyczki lub gniazdka, prowizorycznie połączone przewody). </li>
  </ul>
  <p>Uwagi końcowe:</p>
  <ul>
    <li>
        Przy stałej pracy przy komputerze należy:
        <ul>
            <li>łączyć przemiennie prace związana z obsługą monitora ekranowego z innymi rodzajami prac nie obciążającymi narządu wzroku i wykonywanymi  w innych pozycjach ciała – przy nieprzekraczaniu 1 godziny nieprzerwanej pracy przy obsłudze monitora ekranowego lub</li>
            <li>co najmniej 5-minutową przerwę, wliczaną do czasu pracy, po każdej godzinie pracy przy obsłudze monitora ekranowego.</li>
        </ul>
    </li>
  </ul>
  <p style="margin-top: 30px;">Oświadczam, iż zapoznałem się i akceptuję powyższa zasady bhp przy pracy administracyjno-biurowej.</p>
  <div style="margin-top: 40px; font-size: 10px;">
    <p style="font-size: 14px;">Podpis Zleceniobiorcy</p>
    <p style="font-size: 14px; margin-bottom: 0;">{{ imieNazwisko }}</p>
  </div>
</div>

  <div style="margin-top: 5px; page-break-before: always;">
    <p v-if="!zamawiajacy.includes('Ewa Szcześniewska')"><b>Załącznik nr 7</b></p>
    <p v-else><b>Załącznik nr 7</b></p>
    <p><b>Miesięczny arkusz materiałów</b></p>
    <img src="../assets/arkusz_materialow_2.png" />
  </div>

  <div style="margin-top: 5px;page-break-before: always;">
    <p><em><b>Załącznik nr 7 Kodeks Etyki</b></em></p>
     Wstęp
     <p>W Grupie Tutore wierzymy, że etyczne i odpowiedzialne działanie to fundament zaufania, zarówno w edukacji, jak i w biznesie. Niniejszy Kodeks Etyki przedstawia wartości i zasady, którymi kierujemy się w naszej codziennej pracy. Kodeks określa standardy postępowania, które wspólnie z naszymi partnerami biznesowymi chcemy budować i rozwijać. Grupa Tutore prowadzi działalność zawodową w sposób profesjonalny oraz odpowiedzialny, zarówno społecznie jak i środowiskowo, z poszanowaniem norm etycznych i przepisów prawa. W celu zapewnienia standardów działalności, dokonujemy wyboru partnerów biznesowych w oparciu o wartości wskazane w Kodeksie Etyki. Grupa wspiera swoich partnerów biznesowych w poszanowaniu Kodeksu, udzielając wszelkich niezbędnych wyjaśnień na każde zapytanie aktualnego lub potencjalnego partnera biznesowego.</p>
     Standardy działalności Grupy
     <p>Nasze działania są oparte na uczciwości, odpowiedzialności i jakości, czyli kluczowych wartościach w branży edukacyjnej. W relacjach z partnerami biznesowymi oraz klientami, Spółki Grupy Tutore kierują się zasadami równego traktowania, transparentności oraz otwartości. Grupa szczególny nacisk kładzie na przestrzeganie przepisów o uczciwej konkurencji, ochronie konsumentów i ochronie danych osobowych. Nieustannie podnosimy jakość świadczonych usług, inwestując w innowacje, rozwój i doskonalenie procesów. Grupa nieustannie rozwija systemy kontroli i audytu, aby zapewnić najwyższe standardy funkcjonowania Spółek.</p>
     Prawa człowieka, prawa dziecka
     <p>Grupa Tutore kładzie nacisk na przestrzeganie fundamentalnych praw i wolności, w szczególności takich jak prawo do życia, zdrowia, zachowania integralności, godności i wolności, prawo do swobodnego wyrażania myśli i słowa, a także prawo do rozwoju. Jako organizacja edukacyjna przykładamy szczególną wagę do standardów ochrony małoletnich oraz potwierdzamy, że Spółki Grupy nie korzystały, nie korzystają i nie zamierzają wykorzystywać pracy dzieci ani pracy przymusowej w swojej działalności.</p>
     Prawa pracownicze
     <p>W Grupie Tutore dbamy o naszych pracowników i współpracowników, tworząc bezpieczne i przyjazne środowisko pracy. Przestrzegamy prawa pracy i stosujemy najwyższe standardy etyczne, zapewniając wszystkim równe szanse rozwoju zawodowego. Spółki zabraniają jakiejkolwiek dyskryminacji oraz wspierają różnorodność, otwartość i kulturę wzajemnego szacunku wśród pracowników i współpracowników. Grupa ustanawia Politykę antymobbingową i zobowiązuje się przedsięwziąć kroki w celu przeciwdziałania i zapobiegania wszelkim formom dyskryminacji i mobbingu.</p>
     Prawa zwierząt i środowisko naturalne
     <p>Działamy w sposób zgodny z przepisami dotyczącymi ochrony środowiska i praw zwierząt. Spółki Grupy zmierzają do zminimalizowania negatywnego wpływu na środowisko naturalne, zdrowie ludzi i zwierząt, podejmując działania ograniczające zużycie energii, emisję gazów cieplarnianych i produkcję odpadów. Nasze decyzje biznesowe uwzględniają troskę o przyszłe pokolenia.</p>
     Ochrona informacji
     <p>Poprzez wdrożenie właściwych polityk i procedur chronimy dane osobowe wszystkich osób i organizacji, z którymi współpracujemy: pracowników, współpracowników, klientów i partnerów. Grupa dba o bezpieczeństwo informacji poufnych, tajemnicy handlowej i know-how, zapewniając pełną zgodność z wymaganiami przepisów prawa krajowego, jak i międzynarodowego. W edukacji zaufanie jest kluczowe, dlatego bezpieczeństwo informacji traktujemy jako priorytet.</p>
     Zasady obowiązujące podmioty posiadające relacje biznesowe z Grupą
     <p>Grupa, jak i Spółki podchodzą do swoich partnerów biznesowych z szacunkiem oraz biznesową uczciwością. Zapraszamy partnerów do współpracy w oparciu o wspólne wartości etyczne oraz poszanowanie prawa krajowego i międzynarodowego. Partnerzy biznesowi Grupy nie mogą być objęci jakimikolwiek sankcjami finansowymi ani gospodarczymi, ani współpracować z podmiotami, których one dotykają. Zastrzegamy możliwość odmowy podjęcia współpracy lub zakończenia współpracy w sytuacjach naruszenia zasad etycznych Grupy.</p>
     Przeciwdziałanie przestępstwom, korupcji, defraudacji i innym nadużyciom
     <p>Grupa Tutore sprzeciwia się popełnianiu jakichkolwiek przestępstw, w szczególności przestępstw korupcji, przekupstwa, defraudacji środków, prania pieniędzy, finansowania terroryzmu oraz fałszerstwa pieniędzy, papierów wartościowych lub dokumentów. Każdy pracownik, współpracownik lub partner biznesowy Grupy, który zauważy lub otrzyma informację o nieprawidłowości, może skorzystać z anonimowej procedury zgłoszeń (ochrona sygnalistów), dostępnej na stronie tutorepoland.liniaetyki.pl.</p>
     Postanowienia końcowe
     <p>Kodeks Etyki ma zastosowanie i jest dostępny dla wszystkich pracowników, współpracowników, osób działających na rzecz/w imieniu Spółek, klientów oraz partnerów biznesowych Spółek Grupy. W ramach Grupy mogą być tworzone dodatkowe dokumenty, mające na celu uszczegółowienie zasad opisanych w niniejszym Kodeksie.</p>
     <p>Wszelkie zgłoszenia oraz zapytania związane z Kodeksem Etyki prosimy przesyłać na adres compliance@tutore.eu.</p>

     <p style="margin-top: 30px;">Oświadczam, iż zapoznałem się i akceptuję powyższy Kodeks Etyki.</p>
    <div style="margin-top: 40px; font-size: 10px;">
      <p style="font-size: 14px; margin-bottom: 0;">{{ imieNazwisko }}</p>
      <p style="font-size: 14px;">Podpis Zleceniobiorcy</p>
    </div>
    </div>

  </td></tr>
  </tbody></table>

  </v-container>
</template>

<script>
export default {
  name: 'UmowaTworcaTD2024',
  data () {
    return {
      zamawiajacy: '',
      imieNazwisko: '',
      zamieszkany: '',
      korespondencyjny: '',
      pesel: '',
      nrRachunku: '',
      nrDowodu: '',
      nrTelefonu: '',
      email: '',
      emeryt: '',
      rencista: '',
      orzeczenieNiepelnosprawnosc: '',
      stopienNiepelnosprawnosc: '',
      student: '',
      jedenyTytulDoUbezpieczenia: '',
      chorobowe: '',
      zatrudnionyUmowaPraca: '',
      nazwaUmowaPraca: '',
      wynagrodzenieUmowaPraca: '',
      ubezpieczenieUmowaPraca: '',
      tytulUbezpieczenieUmowaPraca: '',
      dobrowolneUbezpieczenie: '',
      umowaOd: '',
      umowaDo: '',
      urzadSkarbowy: '',
      nrUmowy: '',
      datapocz: '',
      datakon: '',
      kwota: '',
      wypo: '',
      slownie: '',
      kwotapokaz: '',
      slowniepokaz: '',
      godzin: '',
      kowtaplus: '',
      slowniekwotaplus: '',
      prawa: '',
      prawaslownie: '',
      shortUmowa: '',
      obywatelstwo: '',
      przedmiot: '',
      typZajec: '',
      stacjonarneJednostki: '',
      wniosekUbezpieczenie: ''
    }
  },
  created () {
    Object.entries(this.$route.query).forEach(
      ([key, value]) => { this[key] = value }
    )
  },
  methods: {
    shortNrUmowy () {
      let tab = []
      tab = this.nrumowy.split('/')
      this.shortUmowa = `${tab[0]}/${tab[1]}/${tab[2]}/TMat`
      return this.shortUmowa
    },
    dataObowiazywaniaUmowy () {
      if (this.umowaOd === '' || this.umowaOd === '30-12-1899') {
        return 'podpisania umowy przez obie strony'
      } else {
        return `${this.umowaOd} r.`
      }
    },
    aktualnaData() {
      const today = new Date();
      let day = today.getDate();
      if((day+1) <= 10) {
        day = '0' + day
      }
      let month = today.getMonth()+1;
      if ((today.getMonth()+1) < 10) {
        month = '0' + month
      } 
      const todayDate = day+'-'+month+'-'+today.getFullYear()
      return todayDate
    }
  },
  mounted () {
    if (this.zamawiajacy) {
      this.$nextTick(() => {
        window.setTimeout(() => {
          const currentURL = window.location.href
          history.replaceState(history.state, '', '/')
          window.print()
          history.replaceState(history.state, '', currentURL)
        }, 300)
      })
    }
  }
}
</script>

<style scoped>

.page {
  size: 210mm 297mm;
  background-size: 100% 100%;
  line-height: 1.4;
  text-align: justify;
  margin-top: 2px;
  padding-top: 0px;
}

table {
  border: 1px;
  border-collapse: collapse;
  table-layout: fixed;
}

th, td {
  border: 1px;
  border-collapse: collapse;
}

.cointainer {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.cointainer-left {
  width: 20%;
}

.cointainer-right {
  width: 20%;
}

thead {
  display: table-header-group;
}

.table-border {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 5px;
}

.cell-in-first-table {
  margin-top: 2px;
  margin-bottom: 2px;
  margin-left: 10px;
  margin-right: 10px;
}

ul.dashed {
  list-style-type: "- ";
  margin: 0;
}

.underline {
  text-decoration: underline;
}

.pageNum {
  position: absolute;
  right: 0px;
  font-size: 14px;
}

#oswiadczenie {
  padding: 20px;
}

.p-margin {
  margin-bottom: 5px !important;
}

.oswiadczenie-footer {
  font-size: 11px;
}
</style>



// WEBPACK FOOTER //
// src/components/UmowaTworcaTD2024.vue